const { gql } = require('graphql-tag');

// ------------------------------------------------- Move Object -------------------------------------------------
const moveFragment = () => gql`
  fragment Move on moves {
    id
    active
    actual_delivery_mileage
    actual_pickup_mileage
    auto_assign
    cancel_status
    chargeable
    class
    config
    consumer_at_pickup
    consumer_name
    consumer_phone
    consumer_pickup
    consumer_type
    createdat
    customer_id
    dealer_contact
    deliver_by
    delivery_arrived
    delivery_started
    delivery_stop_id
    delivery_successful
    delivery_time
    delivery_workflow_data
    delivery_workflow_id
    driver_id
    driver_name
    lane_id
    lyft_flag
    lyft_trigger_id
    manual_flag
    move_details
    move_failed
    move_type
    payable
    pickup_arrived
    pickup_started
    pickup_stop_id
    pickup_successful
    pickup_time
    pickup_workflow_data
    pickup_workflow_id
    pinnable
    plan_id
    priority
    rate_class_override
    ready_by
    reference_num
    return_ride_id
    ride_type
    sequence
    sequence
    sla_id
    status
    synced_with_tookan
    tags
    tookan_relationship_id
    tracking_link
    updatedat
    vehicle_color
    vehicle_image
    vehicle_make
    vehicle_model
    vehicle_odometer
    vehicle_stock
    vehicle_vin
    vehicle_year
    workflowset_id
    appayments {
      ...APPayment
      accessorial {
        ...Accessorials
      }
    }
    lane {
      ...Lane
    }
    lyft_trigger_move {
      id
      driver_name
    }
    lyftride {
      ...Lyftride
    }
    moveByReturnRideId {
      move_type
      appayments {
        ...APPayment
        accessorial {
          ...Accessorials
        }
      }
    }
    movesByLyftTriggerId {
      ...NestedMove
    }
    parentMove {
      id
      driver_name
      sequence
      consumer_pickup
      consumer_name
      consumer_phone
      consumer_at_pickup
      consumer_type
      status
      cancel_status
    }
    parent_move {
      id
      driver_name
      sequence
      consumer_pickup
      consumer_name
      consumer_phone
      consumer_at_pickup
      consumer_type
      status
      cancel_status
    }
    plan {
      plan_date
      driver_id
      driver_name
    }
    sla {
      id
      description
      duration_hrs
      label
      name
    }
    workflowset {
      id
      name
      description
    }
  }
  ${laneFragment()}
  ${lyftridesFragment()}
  ${nestedMoveFragment()}
  ${appaymentFragment()}
  ${accessorialsFragment()}
`;
const getterMoveFragment = () => gql`
  fragment Move on moves {
    id
    cancel_status
    config
    consumer_at_pickup
    consumer_name
    consumer_phone
    customer_id
    dealer_contact
    deliver_by
    delivery_arrived
    delivery_started
    delivery_successful
    delivery_workflow_data
    delivery_workflow_id
    lane_id
    manual_flag
    move_details
    payer_id
    pickup_arrived
    pickup_started
    pickup_successful
    pickup_workflow_data
    pickup_workflow_id
    ready_by
    reference_num
    sla_id
    status
    vehicle_color
    vehicle_gross_weight_lbs
    vehicle_make
    vehicle_model
    vehicle_stock
    vehicle_vin
    vehicle_year
    workflowset_id
    lane {
      pickup {
        id
        address
        latitude
        longitude
        name
        place_id
      }
      delivery {
        id
        address
        latitude
        longitude
        name
        place_id
      }
    }
    sla {
      id
      description
      duration_hrs
      label
      name
    }
    workflowset {
      id
      name
      description
    }
  }
`;
const updaterMoveFragment = () => gql`
  fragment Move on moves {
    id
    config
    consumer_at_pickup
    consumer_name
    consumer_phone
    customer_id
    dealer_contact
    deliver_by
    delivery_workflow_data
    delivery_workflow_id
    lane_id
    manual_flag
    move_details
    payer_id
    pickup_workflow_data
    pickup_workflow_id
    ready_by
    reference_num
    sla_id
    vehicle_color
    vehicle_gross_weight_lbs
    vehicle_make
    vehicle_model
    vehicle_stock
    vehicle_vin
    vehicle_year
    workflowset_id
    lane {
      pickup {
        id
        address
        latitude
        longitude
        name
        place_id
      }
      delivery {
        id
        address
        latitude
        longitude
        name
        place_id
      }
    }
    sla {
      id
      description
      duration_hrs
      label
      name
    }
    workflowset {
      id
      name
      description
    }
  }
`;
// ------------------------------------------------- Favorite Location Object -------------------------------------------------
const favoriteLocationFragment = () => gql`
  fragment FavoriteLocation on favoritelocations {
    customer_id
    location_id
    location {
      ...Location
    }
  }
  ${locationFragment()}
`;
// ------------------------------------------------- Favorite Lane Object -------------------------------------------------
const favoriteLaneFragment = () => gql`
  fragment FavoriteLane on favoritelanes {
    lane_id
    customer_id
    lane {
      ...Lane
    }
  }
  ${laneFragment()}
`;
// ------------------------------------------------- Location Object -------------------------------------------------
const locationFragment = () => gql`
  fragment Location on locations {
    id
    active
    address
    createdat
    customer_id
    customer {
      ...Customer
    }
    email
    favorite
    latitude
    longitude
    name
    nickname
    phone
    notes
    place_id
    region_id
    region {
      ...Region
    }
    timezone
    tookan_id
    type
    updatedat
  }
  ${customerFragment()}
  ${regionFragment()}
`;
// ------------------------------------------------- Location Object -------------------------------------------------
const locationFragmentNoCustomer = () => gql`
  fragment Location on locations {
    id
    active
    address
    createdat
    customer_id
    email
    favorite
    latitude
    longitude
    name
    nickname
    phone
    notes
    place_id
    region_id
    region {
      ...Region
    }
    timezone
    tookan_id
    type
    updatedat
  }
  ${regionFragment()}
`;
// ------------------------------------------------- Location Object -------------------------------------------------
const simpleLocationFragment = () => gql`
  fragment Location on locations {
    id
    active
    address
    createdat
    customer_id
    email
    favorite
    latitude
    longitude
    name
    nickname
    phone
    notes
    place_id
    region_id
    timezone
    tookan_id
    type
    updatedat
  }
`;
// ------------------------------------------------- Lane Object -------------------------------------------------
const laneFragment = () => gql`
  fragment Lane on lanes {
    id
    active
    description
    createdat
    customer_id
    customer {
      ...Customer
    }
    pickup {
      ...Location
    }
    delivery {
      ...Location
    }
    average_drive_speed_min_per_mile
    average_drive_speed_mph
    dealer_base_discount
    dealer_base_price
    dealer_base_rate
    dealer_base_rate_type
    dealer_stranded_discount
    dealer_stranded_price
    dealer_stranded_rate
    dealer_stranded_rate_type
    delivery_inspection_sec
    destination_location_id
    distance_miles
    driver_base_pay
    driver_base_pay_discount
    driver_drive_pay
    driver_pay_per_kilometer
    driver_pay_per_mile
    driver_pay_per_minute
    driver_rake
    driver_return_pay
    driver_return_pay_discount
    driver_time_pay
    duration_sec
    estimated_rideshare_return_cost
    favorite
    insurance_cost
    insurance_cost_per_mile
    origin_location_id
    pickup_inspection_sec
    return_ride_wait_sec
    tolls
    updatedat
  }
  ${customerFragment()}
  ${locationFragmentNoCustomer()}
`;
// -------------------------------------------- Lane w/o nested fields --------------------------------------------
const simpleLaneFragment = () => gql`
  fragment SimpleLane on lanes {
    id
    active
    description
    createdat
    customer_id
    average_drive_speed_min_per_mile
    average_drive_speed_mph
    dealer_base_discount
    dealer_base_price
    dealer_base_rate
    dealer_base_rate_type
    dealer_stranded_discount
    dealer_stranded_price
    dealer_stranded_rate
    dealer_stranded_rate_type
    delivery_inspection_sec
    destination_location_id
    distance_miles
    driver_base_pay
    driver_base_pay_discount
    driver_drive_pay
    driver_pay_per_kilometer
    driver_pay_per_mile
    driver_pay_per_minute
    driver_rake
    driver_return_pay
    driver_return_pay_discount
    driver_time_pay
    duration_sec
    estimated_rideshare_return_cost
    favorite
    insurance_cost
    insurance_cost_per_mile
    origin_location_id
    pickup_inspection_sec
    return_ride_wait_sec
    tolls
    updatedat
  }
`;
// ------------------------------------------------- Customer Object -------------------------------------------------
const customerFragment = () => gql`
  fragment Customer on customers {
    active
    address
    branded
    email
    id
    name
    phone
    createdat
    updatedat
    billing_frequency
    payment_terms
    auto_pay
    accounting_id
    notify_billing
    config
  }
`;
// ------------------------------------------------- Customer Nested Object -------------------------------------------------
const customerWithRatingFragment = () => gql`
  fragment CustomerWithRating on customers {
    active
    address
    email
    id
    name
    phone
    createdat
    updatedat
    billing_frequency
    payment_terms
    auto_pay
    accounting_id
    notify_billing
    raterulegroups(order_by: { end_date: desc }) {
      id
      customer_id
      name
      description
      begin_date
      end_date
      createdat
      updatedat
      raterules(where: { active: { _eq: "1" } }, order_by: { distance_start: asc }) {
        id
        customer_id
        rate_rule_group_id
        distance_start
        distance_end
        type
        rate
        class
      }
    }
    raterules(where: { active: { _eq: "1" } }, order_by: { distance_start: asc }) {
      id
      customer_id
      rate_rule_group_id
      distance_start
      distance_end
      type
      rate
      class
    }
  }
`;
// ------------------------------------------------- Rate Rules -------------------------------------------------
const raterulesFragment = () => gql`
  fragment Raterules on raterules {
    active
    class
    createdat
    customer_id
    distance_end
    distance_start
    id
    pay_rate_group_id
    rate
    rate_rule_group_id
    type
    updatedat
  }
`;
// ------------------------------------------ Plan Object With Active Moves ------------------------------------------
const planFragment = () => gql`
  fragment Plan on plans {
    id
    driver_id
    driver_name
    createdat
    updatedat
    plan_date
    region_id
    parked_location
    region {
      ...Region
    }
    moves(where: { active: { _eq: 1 } }) {
      ...Move
    }
    moves_aggregate(where: { active: { _eq: 1 } }) {
      aggregate {
        count
      }
    }
  }
  ${moveFragment()}
  ${regionFragment()}
`;
// ------------------------------------------ Lyftrides Object With Attempts ------------------------------------------
const lyftridesFragment = () => gql`
  fragment Lyftride on lyftrides {
    move_id
    passenger_phone
    pickup_location_type
    latitude
    longitude
    active_attempt
    last_attempt
    createdat
    updatedat
    activeAttempt {
      ...Lyftrideattempts
    }
    attempts: attempts(order_by: { createdat: desc_nulls_last }) {
      ...Lyftrideattempts
    }
  }
  ${lyftrideattemptsFragment()}
`;
// ------------------------------------ Lyftrideattempts Object with current and all ----------------------------------
const lyftrideattemptsFragment = () => gql`
  fragment Lyftrideattempts on lyftrideattempts {
    id
    active
    move_id
    origin_location_id
    destination_location_id
    driver_first_name
    driver_id
    driver_phone
    driver_rating
    driver_vehicle_color
    driver_vehicle_img_url
    driver_vehicle_license_plate
    driver_vehicle_license_plate_state
    driver_vehicle_make
    driver_vehicle_model
    driver_vehicle_year
    estimated_cost_max
    estimated_cost_min
    estimated_ride_cost
    passenger_phone
    ride_cost
    ride_distance
    ride_duration
    ride_id
    status
    stop_id
    surge_cost_percentage
    createdat
    updatedat
    requested_at
    requester
  }
`;
// ------------------------------------ Lyftrideattempts Object with current and all ----------------------------------
const nestedMoveFragment = () => gql`
  fragment NestedMove on moves {
    id
    driver_id
    driver_name
    parent_move {
      id
    }
  }
`;
// -------------------------------------------------- Regions Object  -------------------------------------------------
const regionFragment = () => gql`
  fragment Region on regions {
    id
    team_id
    name
    description
    geofence
    createdat
    updatedat
    last_synced
    region_id
    status
  }
`;
// -------------------------------------------------- Accessorial Object  -------------------------------------------------
const accessorialsFragment = () => gql`
  fragment Accessorials on accessorials {
    id
    move_id
    code
    status
    notes
    cost
    ap_amount
    ar_amount
    createdat
    updatedat
  }
`;
// -------------------------------------------------- Authorization Object  -------------------------------------------------
const authorizationFragment = () => gql`
  fragment Authorizations on authorizations {
    id
    vendor_auth_id
    card_id
    last4
    merchant_name
    merchant_city
    merchant_state
    merchant_postalcode
    max_charge
    driver_id
    driver_name
    auth_attempts
    last_declined_at
    last_declined_reason
    approved_at
    created_by
    created_at
    updated_at
    valid_from
    valid_to
  }
`;
// -------------------------------------------------- AP Payment Object  -------------------------------------------------
const appaymentFragment = () => gql`
  fragment APPayment on appayments {
    active
    id
    driver_id
    move_id
    status
    ach_transaction_id
    amount
    createdat
    updatedat
    notes
    author
    source_event_id
    type
    accessorial_id
  }
`;
// --------------------------------------------------- Event Log Object  -------------------------------------------------
const eventlogFragment = () => gql`
  fragment Eventlog on eventlogs {
    id
    event_time_utc
    created_at_utc
    actiontype_id
    user
    role_id
    metadata
    customer_id
    move_id
    lane_id
    location_id
    driver_id
  }
`;

// ------------------------------------------------- Notification Object -------------------------------------------------
const notificationFragment = () => gql`
  fragment Notification on notifications {
    id
    type
    title
    body
    createdat
    createdby
    assignedto
    assignedby
    assignedat
    duedate
    resolvedby
    resolvedat
    notes
    json
  }
`;

// ------------------------------------------------- Invoice Object -------------------------------------------------

const invoiceFragment = () => gql`
  fragment Invoices on arinvoices {
    id
    status
    due_amount: armoves_aggregate(
      where: { due_amount: { _gt: "0" }, active: { _eq: "1" }, type: { _nilike: "spoilage" } }
    ) {
      aggregate {
        sum {
          due_amount
        }
      }
    }
    paid_amount: armoves_aggregate(
      where: { due_amount: { _gt: "0" }, active: { _eq: "1" }, type: { _nilike: "spoilage" } }
    ) {
      aggregate {
        sum {
          paid_amount
        }
      }
    }
    discount_amount: armoves_aggregate(
      where: { due_amount: { _gt: "0" }, active: { _eq: "1" }, type: { _nilike: "spoilage" } }
    ) {
      aggregate {
        sum {
          discount_amount
        }
      }
    }
    payments: arpayments {
      status
      createdat
      amount
      method {
        id
        name
        type
        account_number
      }
      details {
        charge: armove {
          id
          move_id
        }
        amount
      }
    }
    start_datetime
    end_datetime
    customer {
      id
      name
    }
    charges: armoves(where: { due_amount: { _gt: "0" }, active: { _eq: "1" }, type: { _nilike: "spoilage" } }) {
      id
      move_id
      type
      status
      disputed
      dispute_reason
      discount_amount
      discount_reason
      due_amount
      paid_amount

      details(where: { amount: { _gt: "0" } }) {
        name
        notes
        amount
        documents {
          name
          url
          mime_type
          created_at
        }
        mileage_band: raterule {
          type
          rate
          distance_start
          distance_end
          contract: raterulegroup {
            begin_date
            end_date
            workflowset_id
          }
        }
      }
    }
  }
`;

// ------------------------------------------ Associated value types for fields  ------------------------------------------
const moveFieldTypes = {
  id: 'bigint',
  active: 'smallint',
  auto_assign: 'smallint',
  cancel_status: 'String',
  class: 'String',
  config: 'jsonb',
  consumer_pickup: 'Boolean',
  consumer_name: 'String',
  consumer_phone: 'String',
  consumer_at_pickup: 'smallint',
  consumer_type: 'String',
  createdat: 'timestamptz',
  customer_id: 'bigint',
  dealer_contact: 'String',
  delivery_arrived: 'timestamptz',
  deliver_by: 'timestamptz',
  delivery_started: 'timestamptz',
  delivery_stop_id: 'String',
  delivery_successful: 'timestamptz',
  delivery_time: 'timestamptz',
  driver_name: 'String',
  driver_id: 'bigint',
  lane_id: 'bigint',
  lyft_flag: 'smallint',
  lyft_trigger_id: 'bigint',
  manual_flag: 'Boolean',
  move_details: 'String',
  move_failed: 'timestamptz',
  move_type: 'String',
  pickup_arrived: 'timestamptz',
  pickup_started: 'timestamptz',
  pickup_stop_id: 'String',
  pickup_successful: 'timestamptz',
  pickup_time: 'timestamptz',
  plan_id: 'bigint',
  rate_class_override: 'smallint',
  ready_by: 'timestamptz',
  reference_num: 'String',
  return_ride_id: 'bigint',
  parent_move_id: 'bigint',
  ride_type: 'String',
  sequence: 'bigint',
  status: 'String',
  tookan_relationship_id: 'String',
  tracking_link: 'String',
  vehicle_color: 'String',
  vehicle_image: 'String',
  vehicle_make: 'String',
  vehicle_model: 'String',
  vehicle_odometer: 'String',
  vehicle_stock: 'String',
  vehicle_vin: 'String',
  vehicle_year: 'String',
  tags: 'String',
  sequence: 'bigint',
  synced_with_tookan: 'timestamptz',
  priority: 'bigint',
  pinnable: 'Boolean',
  actual_pickup_mileage: 'bigint',
  actual_delivery_mileage: 'bigint',
  chargeable: 'Boolean',
  updatedat: 'timestamptz',
  payable: 'Boolean',
};

const favoriteLocationFieldTypes = {
  customer_id: 'bigint',
  location_id: 'bigint',
};

const favoriteLaneFieldTypes = {
  lane_id: 'bigint',
  customer_id: 'bigint',
};

const locationFieldTypes = {
  id: 'bigint',
  active: 'smallint',
  address: 'String',
  address_line_one: 'String',
  address_line_two: 'String',
  city: 'String',
  state: 'String',
  zip_code: 'String',
  createdat: 'timestamptz',
  customer_id: 'bigint',
  email: 'String',
  favorite: 'Boolean',
  latitude: 'numeric',
  longitude: 'numeric',
  name: 'String',
  nickname: 'String',
  phone: 'String',
  notes: 'String',
  place_id: 'String',
  region_id: 'bigint',
  tookan_id: 'bigint',
  type: 'String',
  updatedat: 'timestamptz',
};

const laneFieldTypes = {
  id: 'bigint',
  active: 'smallint',
  description: 'String',
  createdat: 'timestamptz',
  customer_id: 'bigint',
  average_drive_speed_min_per_mile: 'numeric',
  average_drive_speed_mph: 'numeric',
  dealer_base_discount: 'numeric',
  dealer_base_price: 'numeric',
  dealer_base_rate: 'numeric',
  dealer_base_rate_type: 'String',
  dealer_stranded_discount: 'numeric',
  dealer_stranded_price: 'numeric',
  dealer_stranded_rate: 'numeric',
  dealer_stranded_rate_type: 'String',
  delivery_inspection_sec: 'bigint',
  destination_location_id: 'bigint',
  distance_miles: 'numeric',
  driver_base_pay: 'numeric',
  driver_base_pay_discount: 'numeric',
  driver_drive_pay: 'numeric',
  driver_pay_per_kilometer: 'numeric',
  driver_pay_per_mile: 'numeric',
  driver_pay_per_minute: 'numeric',
  driver_rake: 'numeric',
  driver_return_pay: 'numeric',
  driver_return_pay_discount: 'numeric',
  driver_time_pay: 'numeric',
  duration_sec: 'bigint',
  estimated_rideshare_return_cost: 'numeric',
  favorite: 'Boolean',
  insurance_cost: 'numeric',
  insurance_cost_per_mile: 'numeric',
  origin_location_id: 'bigint',
  pickup_inspection_sec: 'bigint',
  return_ride_wait_sec: 'bigint',
  tolls: 'numeric',
  updatedat: 'timestamptz',
};

const customerFieldTypes = {
  active: 'smallint',
  address: 'String',
  email: 'String',
  id: 'bigint',
  name: 'String',
  phone: 'String',
  createdat: 'timestamptz',
  updatedat: 'timestamptz',
  billing_frequency: 'String',
  payment_terms: 'numeric',
  auto_pay: 'Boolean',
  accounting_id: 'String',
  notify_billing: 'Boolean',
  config: 'JSONB',
};

const rateruleFieldTypes = {
  active: 'smallint',
  class: 'String',
  createdat: 'timestamptz',
  customer_id: 'bigint',
  distance_end: 'numeric',
  distance_start: 'numeric',
  id: 'bigint',
  pay_rate_group_id: 'bigint',
  rate: 'numeric',
  rate_rule_group_id: 'bigint',
  type: 'String',
  updatedat: 'timestamptz',
};

const planFieldTypes = {
  id: 'bigint',
  driver_id: 'bigint',
  driver_name: 'String',
  createdat: 'timestamptz',
  updatedat: 'timestamptz',
  plan_date: 'date',
  region_id: 'bigint',
  parked_location: 'bigint',
};

const lyftrideFieldTypes = {
  move_id: 'bigint',
  active_attempt: 'bigint',
  last_attempt: 'bigint',
  passenger_phone: 'String',
  pickup_location_type: 'String',
  latitude: 'numeric',
  longitude: 'numeric',
  createdat: 'timestamptz',
  updatedat: 'timestamptz',
};

const lyftrideattemptFieldTypes = {
  id: 'bigint',
  active: 'smallint',
  move_id: 'bigint',
  origin_location_id: 'bigint',
  destination_location_id: 'bigint',
  driver_first_name: 'String',
  driver_id: 'String',
  driver_phone: 'String',
  driver_rating: 'numeric',
  driver_vehicle_color: 'String',
  driver_vehicle_img_url: 'String',
  driver_vehicle_license_plate: 'String',
  driver_vehicle_license_plate_state: 'String',
  driver_vehicle_make: 'String',
  driver_vehicle_model: 'String',
  driver_vehicle_year: 'bigint',
  estimated_cost_max: 'numeric',
  estimated_cost_min: 'numeric',
  estimated_ride_cost: 'numeric',
  passenger_phone: 'String',
  ride_cost: 'numeric',
  ride_distance: 'numeric',
  ride_duration: 'numeric',
  ride_id: 'String',
  status: 'String',
  stop_id: 'bigint',
  surge_cost_percentage: 'String',
  createdat: 'timestamptz',
  updatedat: 'timestamptz',
  requested_at: 'timestamptz',
  requester: 'String',
};

const regionFieldTypes = {
  id: 'bigint',
  team_id: 'bigint',
  name: 'String',
  description: 'String',
  geofence: 'geometry',
  createdat: 'timestamptz',
  updatedat: 'timestamptz',
  last_synced: 'timestamptz',
  region_id: 'bigint',
  status: 'String',
};

const accessorialFieldTypes = {
  id: 'bigint',
  move_id: 'bigint',
  code: 'String',
  status: 'String',
  notes: 'String',
  cost: 'numeric',
  ap_amount: 'numeric',
  ar_amount: 'numeric',
  createdat: 'timestamptz',
  updatedat: 'timestamptz',
};

const authorizationFieldTypes = {
  id: 'bigint',
  vendor_auth_id: 'String',
  card_id: 'String',
  last4: 'String',
  merchant_name: 'String',
  merchant_city: 'String',
  merchant_state: 'String',
  merchant_postalcode: 'String',
  max_charge: 'numeric',
  driver_id: 'bigint',
  driver_name: 'String',
  auth_attempts: 'smallint',
  last_declined_at: 'timestamptz',
  last_declined_reason: 'String',
  created_by: 'String',
  created_at: 'timestamptz',
  updated_at: 'timestamptz',
  valid_from: 'timestamptz',
  valid_to: 'timestamptz',
};

const appaymentFieldTypes = {
  active: 'smallint',
  id: 'bigint',
  driver_id: 'bigint',
  move_id: 'bigint',
  status: 'String',
  ach_transaction_id: 'String',
  amount: 'numeric',
  createdat: 'timestamptz',
  updatedat: 'timestamptz',
  notes: 'String',
  author: 'String',
  source_event_id: 'String',
  type: 'String',
  accessorial_id: 'bigint',
};

const notificationFieldTypes = {
  id: 'bigint',
  type: 'String',
  title: 'String',
  body: 'String',
  createdby: 'String',
  createdat: 'timestamptz',
  assignedat: 'timestamptz',
  duedate: 'timestamptz',
  assignedby: 'String',
  assignedto: 'String',
  resolvedby: 'String',
  resolvedat: 'timestamptz',
  notes: 'String',
};

// Exports
var fragments = {
  move: () => moveFragment(),
  favoriteLocation: () => favoriteLocationFragment(),
  favoriteLane: () => favoriteLaneFragment(),
  location: () => locationFragment(),
  notification: () => notificationFragment(),
  lane: () => laneFragment(),
  simpleLane: () => simpleLaneFragment(),
  simpleLocation: () => simpleLocationFragment(),
  customer: () => customerFragment(),
  raterules: () => raterulesFragment(),
  plan: () => planFragment(),
  lyftrides: () => lyftridesFragment(),
  lyftrideattempts: () => lyftrideattemptsFragment(),
  nestedMove: () => nestedMoveFragment(),
  region: () => regionFragment(),
  accessorials: () => accessorialsFragment(),
  authorizations: () => authorizationFragment(),
  appayment: () => appaymentFragment(),
  customerWithRating: () => customerWithRatingFragment(),
  eventlog: () => eventlogFragment(),
  getterMove: () => getterMoveFragment(),
  updaterMove: () => updaterMoveFragment(),
  invoices: () => invoiceFragment(),
};

var types = {
  moves: moveFieldTypes,
  favoritelocations: favoriteLocationFieldTypes,
  favoritelanes: favoriteLaneFieldTypes,
  locations: locationFieldTypes,
  lanes: laneFieldTypes,
  customers: customerFieldTypes,
  raterules: rateruleFieldTypes,
  plans: planFieldTypes,
  lyftrides: lyftrideFieldTypes,
  lyftrideattempts: lyftrideattemptFieldTypes,
  regions: regionFieldTypes,
  accessorials: accessorialFieldTypes,
  authorizations: authorizationFieldTypes,
  appayments: appaymentFieldTypes,
  notifications: notificationFieldTypes,
};

module.exports = {
  fragments,
  types,
};
